import stls from '@f_qwep/styles/component/orders/Orders.module.sass';
import { dateNormalizer } from '@f_utils/dateNormalizer';
import { Tooltip } from '@mui/material';

export function CellDate({ info }: any) {
    const date = dateNormalizer({date: info.row.original.datetimeOrder, format: 'locale', lang: 'ru'})
    return <Tooltip title={date}><p className={stls.cellDate}>{date}</p></Tooltip>
}
